/**
 * Created by danielg on 4/27/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    /////////////////////////////////// CONSTANT VARIABLES ///////////////////////////////////
    var APPLICATION_TYPE = 'AMSController';
    var CONVERSATION_STATES = {
        OPEN: 'OPEN',
        CLOSE: 'CLOSE',
        LOCKED: 'LOCKED'
    };
    var DIALOG_TYPES = {
        MAIN: "MAIN",
        POST_SURVEY: "POST_SURVEY",
        AGENT: "AGENT",
        OTHER: "OTHER"
    };
    var BADGES = {
        FIRST_TIME: 'FIRST_TIME',
        OVERDUE: 'OVERDUE',
        URGENT: 'URGENT',
        IN_QUEUE: 'IN_QUEUE',
        IN_SURVEY: 'IN_SURVEY',
        NO_ACTIVE_DIALOG: 'NO_ACTIVE_DIALOG'
    };
    var NOTIFICATION_TYPES = {
        UPSERT: 'UPSERT',
        DELETE: 'DELETE'
    };
    var CONTENT_TYPES = {
        TEXT_PLAIN: 'text/plain',
        EXTERNAL_FILE: 'external/file',
        HOSTED_FILE:'hosted/file',
        SECURE_FORM_SUBMISSION: 'forms/secure-submission',
        SECURE_FORM_INVITATION: 'forms/secure-invitation',
        RICH_CONTENT: 'richContent'
    };
    // KEEP IN UPPER CASE
    var FILE_TYPES = {
        IMG: 'IMG',
        JPG: 'JPG',
        PNG: 'PNG',
        TIF: 'TIF',
        JPEG: 'JPEG',
        GIF: 'GIF',
        AUDIO: 'AUDIO',
        M4A: 'M4A',
        AAC: 'AAC',
        MP3: 'MP3',
        AVI: 'AVI',
        PCM: 'PCM',
        OTHER: 'OTHER'
    };
    var SOCKET_STATES = {
        CONNECTED: 'connected',
        CLOSED: 'closed',
        NON_RESPONSIVE: 'non_responsive'
    };
    var MODEL_PATHS = {
        socketState: 'amsService.socketState',
        userId: 'agent.messagingUserId',
        connectionsListModelLocations: {
            state: 'connectionsList.state',
            status: 'connectionsList.state.status',
            count: 'connectionsList.count',
            lastQuery: 'connectionsList.lastQuery',
            data: 'connectionsList.data',
            array: 'connectionsList.array',
            isDirty: 'connectionsList.isDirty',
            openConversations: 'connectionsList.openConversations',
            modelLocationName: 'connectionsList'
        },
        external: {
            resumed: 'agent.chatsResumedCount'
        },
        userProfiles: 'userProfiles'
    };

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////
    var logger = WebAgentLogger.getLogger(APPLICATION_TYPE);
    var amsCommunicationChannel = webAgentStatics.COMMUNICATION_CHANNELS.AMS;
    var webAgentChannel, webAgentMediaCodes;

    /////////////////////////////////// INITIALIZATION ///////////////////////////////////
    var lpAmsController = BaseController.extend(function (options) {
        this.model = options.model;
        this.agentSubscriptionId = null;
        this.initialize();
    });

    lpAmsController.prototype.initialize = function () {

        // setting the references for the cross application channel.
        webAgentChannel = agentLEManager.channelLE();
        webAgentMediaCodes = agentLEManager.getLEMediaCodesWebAgent();

        // exposing the external interface for brand profiles.
        webAgentChannel.comply(webAgentMediaCodes.commands.getBrandProfile, this.getBrandProfile.bind(this));
        webAgentChannel.comply(webAgentMediaCodes.commands.setBrandProfile, this.setBrandProfile.bind(this));

        // register the AMS Domain events to the controller.
        lpTag.WebAgent.channel.bind(amsCommunicationChannel.name, amsCommunicationChannel.events.connectionStateChange, onConnectionStateChange.bind(this));
        lpTag.WebAgent.channel.bind(amsCommunicationChannel.name, amsCommunicationChannel.events.onBrandProfile, onBrandProfile.bind(this));

        // binding the application ready state (currently tye 'Resume' is the ready event).
        // NOTE: do we want to be bound to this event? this is "Real Time" domain term for all chats loaded.
        this.model.bind(MODEL_PATHS.external.resumed, _onResume, this);
    };

    /////////////////////////////////// PUBLIC CLASS VARIABLES ///////////////////////////////////
    lpAmsController.prototype.applicationType = APPLICATION_TYPE;

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////
    /**
     * issue a call to the ams client to get the brand profile.
     * @returns {*}
     */
    lpAmsController.prototype.getBrandProfile = function () {
        return lpTag.WebAgent.amsConnectionController.amsClient.getBrandProfile.apply(this, arguments);
    };

    /**
     * issue a call to the ams client to set the profile.
     * @returns {*}
     */
    lpAmsController.prototype.setBrandProfile = function (request) {
        return lpTag.WebAgent.amsConnectionController.amsClient.setBrandProfile.apply(this, arguments);
    };

    /**
     * return the ams server time.
     */
    lpAmsController.prototype.getServerTime = function () {
        return lpTag.WebAgent.logicController.getCurrentTimeWithDiff(this.getTimeDiff());
    };

    /**
     * Returns the AMS server time diff
     */
    lpAmsController.prototype.getTimeDiff = function () {
        return lpTag.WebAgent.amsConnectionController.amsClient && lpTag.WebAgent.amsConnectionController.amsClient.getTimeDiff && lpTag.WebAgent.amsConnectionController.amsClient.getTimeDiff();
    };

    /**
     * Generate PCI download token
     */
    lpAmsController.prototype.generatePciDownloadToken = function (request) {
        return lpTag.WebAgent.amsConnectionController.amsClient && lpTag.WebAgent.amsConnectionController.amsClient.generateDownloadToken && lpTag.WebAgent.amsConnectionController.amsClient.generateDownloadToken(request);
    };

    /**
     * Send secure form request
     */
    lpAmsController.prototype.sendPCIMessage = function (request) {
        return lpTag.WebAgent.amsConnectionController.amsClient && lpTag.WebAgent.amsConnectionController.amsClient.sendPCIMessage && lpTag.WebAgent.amsConnectionController.amsClient.sendPCIMessage(request);
    };

    /**
     * Assign Conversation To Agent (take over conversation)
     */
    lpAmsController.prototype.assignConversationToAgent = function (request) {
        return lpTag.WebAgent.amsConnectionController.amsClient && lpTag.WebAgent.amsConnectionController.amsClient.assignConversationToAgent && lpTag.WebAgent.amsConnectionController.amsClient.assignConversationToAgent(request);
    };


    /**
     *
     * @param conversationId
     * @param autoOpen
     */
    lpAmsController.prototype.createMyEngagementForConversation = function (conversationId, autoOpen) {
        lpTag.WebAgent.amsConversationController.openEngagement({chatId: conversationId, autoOpen: autoOpen});
    };

    lpAmsController.prototype.createAgentSubscription = function () {
        var self = this;
        this.model.bind(MODEL_PATHS.userId, onAgentIdChange);

        function onAgentIdChange(data) {
            if(data && data.newValue) {
                self.logger.debug('creating agent subscription.');
                var agentId = data.newValue;
                var accountId = self.model.get('account');

                var conversationPostProcessHandlers = {};
                conversationPostProcessHandlers[NOTIFICATION_TYPES.UPSERT] = function (conversationData) {
                    lpTag.WebAgent.amsConversationController.updateChatModelByConversation(conversationData);
                };
                conversationPostProcessHandlers[NOTIFICATION_TYPES.DELETE] = function (conversationData) {
                    lpTag.WebAgent.amsConversationController.updateChatModelByConversation(conversationData);
                };

                lpTag.WebAgent.amsSubscriptionsController.subscribe(
                    {
                        agentIds: [agentId],
                        brandId: accountId,
                        convState: ["OPEN"]
                    },
                    {
                        conversationPostProcessHandlers: conversationPostProcessHandlers,
                        trackActiveConversations: false // No need to sync, this is not a "Table" data.
                    }, function (err, result) {
                        if (err) {
                            self.logger.error('creating agent subscription failed. ', 'subscribe', err);
                            return;
                        }
                        self.agentSubscriptionId = result.subscriptionId;
                        self.logger.debug('agent subscription created successfully: ' + self.agentSubscriptionId);
                    }
                );

                self.model.unbind(MODEL_PATHS.userId, onAgentIdChange);
            }
        }
    };


    lpAmsController.prototype.removeAgentSubscription = function () {
        if (this.agentSubscriptionId) {
            this.logger.debug('agent subscription found, unsubscribing:' + this.agentSubscriptionId);
            lpTag.WebAgent.amsSubscriptionsController.unsubscribe(this.agentSubscriptionId);
            this.agentSubscriptionId = null;
        }
    };

    /////////////////////////////////// INTERNAL METHODS ///////////////////////////////////

    /**
     * Called once the agent is fully logged-in and all the chats are resumed.
     * Here we create an instance of the amsClient, and initialize it.
     * @private
     */
    function _onResume() {
        this.model.unbind(MODEL_PATHS.external.resumed, _onResume, this);


        var agentId = this.model.get('agent.id');
        if(!agentId){
            this.logger.error('Diagnostic: messaging agent Id is not available while initializing the messaging flow');
        }

        // Messaging Agent ID is avaliavle after the resolve of the agent.id + the creation of the agent.messagingUserId
        // The lpUserProfileController is incharge of creating this data based on global agent data.
        // Only agter we have the messaging User ID we will initialize the flow.
        var self = this;
        this.model.bind(MODEL_PATHS.userId, onUserIdAvailable);
        function onUserIdAvailable(){
            self.model.unbind(MODEL_PATHS.userId, onUserIdAvailable);
            lpTag.WebAgent.amsConnectionController.init();
        }
    }

    /**
     *
     * @param connectionState
     */
    function onConnectionStateChange(connectionState) {
        this.model.modify(MODEL_PATHS.socketState, connectionState);
        webAgentChannel.trigger(webAgentMediaCodes.vent.onAMSConnectionStatus, {connected: (connectionState === SOCKET_STATES.CONNECTED)});
        switch (connectionState) {
            case SOCKET_STATES.CONNECTED:
                handleConnectedState.call(this);
                this.createAgentSubscription();
                break;
            case SOCKET_STATES.CLOSED:
                this.removeAgentSubscription();
                break;
            case SOCKET_STATES.NON_RESPONSIVE:
                break;
        }
    }

    /**
     * Publishes the brand profile on the webAgent channel
     * @param profileData
     * @private
     */
    function onBrandProfile(profileData) {
        webAgentChannel.trigger(webAgentMediaCodes.vent.onBrandProfile, profileData);
        logger.debug('brand profile received: ' + JSON.stringify(profileData));
    }

    function handleConnectedState(){
        lpTag.WebAgent.amsUserProfilesController.getMyProfile();
        lpTag.WebAgent.amsEngagementsSubscriptionsManager.start();
        lpTag.WebAgent.amsAgentStatusController.updateAMSAvailability();
        lpTag.WebAgent.amsAgentStatusController.subscribeToAgentStatusChange();
        queryActiveConversationsMessages.call(this);
    }

    function queryActiveConversationsMessages() {
        var activeChat,
            engagements = this.model.get("participants").myEngagements;

        if(engagements) {
            for(var key in engagements) {
                activeChat = engagements[key].participantInfo &&  engagements[key].participantInfo.activeChat;
                if(activeChat) {
                    lpTag.WebAgent.amsMessagesController.queryMessages(activeChat);
                }
            }
        }
    }

    /////////////////////////////////// EXPORTING TO CLASS ///////////////////////////////////
    lpAmsController.CONVERSATION_STATES = CONVERSATION_STATES;
    lpAmsController.DIALOG_TYPES = DIALOG_TYPES;
    lpAmsController.BADGES = BADGES;
    lpAmsController.NOTIFICATION_TYPES = NOTIFICATION_TYPES;
    lpAmsController.CONTENT_TYPES = CONTENT_TYPES;
    lpAmsController.FILE_TYPES = FILE_TYPES;
    lpAmsController.SOCKET_STATES = SOCKET_STATES;
    lpAmsController.MODEL_PATHS = MODEL_PATHS;


    return lpAmsController;

});
